// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__SuC4L","colMaxWidth":"Table_colMaxWidth__IxwSQ"};